function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .finance-icon {\n            fill: none;\n            stroke: #6e6e6e;\n            }\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "savings_3",
  transform: "translate(0.65 0.754)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9101",
  "data-name": "Path 9101",
  d: "M13.8,40.774a7.88,7.88,0,0,1-2.979,1.487c-.529.073-1.064.141-1.588.259h0v7.141l8.628.653a8.217,8.217,0,0,0,5.987-2.371L27.2,44.6l2.444-2.433a1.69,1.69,0,0,0-1.239-2.816h0a1.532,1.532,0,0,0-1.087.394L24.1,42.751a5.249,5.249,0,0,1-3.773,1.385l-3.773-.118",
  transform: "translate(-6.205 -19.019)",
  className: "finance-icon",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9102",
  "data-name": "Path 9102",
  d: "M26.2,38.454a4.973,4.973,0,0,1,.513-.248,1.256,1.256,0,0,1,1.369.231h0a1.3,1.3,0,0,1,.208,1.633.7.7,0,0,1-.18.186l-5.829,3.2",
  transform: "translate(-11.961 -18.473)",
  className: "finance-icon",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9103",
  "data-name": "Path 9103",
  d: "M26.34,40.5c1.042-.749,5.463-1.014,6.64-1.774",
  transform: "translate(-18.742 -18.75)",
  className: "finance-icon",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9104",
  "data-name": "Path 9104",
  d: "M49.27,50.571v2.157H46.24l.006-11.292,3.024-.006v2",
  transform: "translate(-46.24 -19.929)",
  className: "finance-icon",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_123",
  "data-name": "Line 123",
  y2: 1.402,
  transform: "translate(1.515 29.425)",
  className: "finance-icon",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9105",
  "data-name": "Path 9105",
  d: "M28.466,4.007a2.63,2.63,0,0,1,3-.377l.051.045h0l-1.588,3.1,2.591,4.37a6.963,6.963,0,0,1-4.911,10.5c-.152,0-.31.034-.462.039s-.242,0-.366,0h-.366a1.991,1.991,0,0,1-.462-.039,6.966,6.966,0,0,1-4.911-10.5l2.6-4.37-1.594-3.1.062-.045a2.033,2.033,0,0,1,2.619.225l.253.253.2-.169A2.54,2.54,0,0,1,27.565,3.5a2.675,2.675,0,0,1,.732.383",
  transform: "translate(-15.726 -3.254)",
  className: "finance-icon",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9106",
  "data-name": "Path 9106",
  d: "M29.158,4.494l-.073-.068L29,4.37",
  transform: "translate(-16.418 -3.741)",
  className: "finance-icon",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9107",
  "data-name": "Path 9107",
  d: "M32.821,21.041a4.14,4.14,0,1,0-8.274,0",
  transform: "translate(-17.575 -9.148)",
  className: "finance-icon",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9108",
  "data-name": "Path 9108",
  d: "M24.55,24.37a4.14,4.14,0,0,0,8.274,0",
  transform: "translate(-17.577 -12.477)",
  className: "finance-icon",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9109",
  "data-name": "Path 9109",
  d: "M32.009,21.594l-1.38-.208a.682.682,0,0,0-.445,1.256l1.4.839a.682.682,0,0,1-.451,1.256l-1.38-.192",
  transform: "translate(-19.69 -11.171)",
  className: "finance-icon",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3
}), /*#__PURE__*/React.createElement("line", {
  className: "finance-icon",
  id: "Line_124",
  "data-name": "Line 124",
  y1: 0.867,
  transform: "translate(11.225 9.393)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3
}), /*#__PURE__*/React.createElement("line", {
  className: "finance-icon",
  id: "Line_125",
  "data-name": "Line 125",
  y1: 0.856,
  transform: "translate(11.225 13.533)",
  stroke: "#6e6e6e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9110",
  "data-name": "Path 9110",
  d: "M32.821,21.041a4.14,4.14,0,1,0-8.274,0",
  transform: "translate(-17.575 -9.148)",
  className: "finance-icon",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9111",
  "data-name": "Path 9111",
  d: "M24.55,24.37a4.14,4.14,0,0,0,8.274,0",
  transform: "translate(-17.577 -12.477)",
  className: "finance-icon",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9112",
  "data-name": "Path 9112",
  d: "M24.55,24.37a4.14,4.14,0,0,0,8.274,0",
  transform: "translate(-17.577 -12.477)",
  className: "finance-icon",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9113",
  "data-name": "Path 9113",
  d: "M32.821,21.041a4.14,4.14,0,1,0-8.274,0",
  transform: "translate(-17.575 -9.148)",
  className: "finance-icon",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3
}), /*#__PURE__*/React.createElement("line", {
  className: "finance-icon",
  id: "Line_126",
  "data-name": "Line 126",
  x1: 6.291,
  transform: "translate(7.908 3.518)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3
}));

function SvgFinanceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.201,
    height: 34.203,
    viewBox: "0 0 25.201 34.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceIcon);
export default __webpack_public_path__ + "static/media/finance-icon.6337b83c.svg";
export { ForwardRef as ReactComponent };